import { $locale } from 'stores/locale';
import { useStore } from 'effector-react';
import { i18nObject } from 'i18n/i18n-util';
import { TranslationFunctions } from 'i18n/i18n-types';

export const useI18nObject = (): TranslationFunctions => {
  const locale = useStore($locale);
  return i18nObject(locale);
};
